import { render } from "./PengumumanLelang.vue?vue&type=template&id=0312b232"
import script from "./PengumumanLelang.vue?vue&type=script&lang=js"
export * from "./PengumumanLelang.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__